import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus, AlertTriangle, Star } from "lucide-react";
import { DEFAULT_DOMAINS } from "./constants";

const TaskForm = ({
  open,
  onOpenChange,
  editingTask,
  newTask,
  setNewTask,
  onSubmit,
  onReset,
  customDomains,
  priorityTasksCount
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { onOpenChange(isOpen); if (!isOpen) onReset(); }}>
      <DialogTrigger asChild>
        <Button className="rounded-full bg-indigo-600 hover:bg-indigo-700">
          <Plus className="w-4 h-4 mr-2" /> Nuovo
        </Button>
      </DialogTrigger>
      <DialogContent className="rounded-2xl max-w-lg">
        <DialogHeader>
          <DialogTitle>{editingTask ? "Modifica Compito" : "Nuovo Compito"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 pt-4">
          <Input
            value={newTask.title}
            onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
            placeholder="Cosa devi fare?"
            className="rounded-xl"
          />
          <Select 
            value={newTask.custom_domain ? `custom:${newTask.custom_domain}` : newTask.domain} 
            onValueChange={(v) => {
              if (v.startsWith('custom:')) {
                setNewTask({ ...newTask, domain: 'altro', custom_domain: v.replace('custom:', '') });
              } else {
                setNewTask({ ...newTask, domain: v, custom_domain: '' });
              }
            }}
          >
            <SelectTrigger className="rounded-xl">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {Object.entries(DEFAULT_DOMAINS).map(([key, { label, emoji }]) => (
                <SelectItem key={key} value={key}>{emoji} {label}</SelectItem>
              ))}
              {customDomains.length > 0 && customDomains.map(d => (
                <SelectItem key={d.domain_id} value={`custom:${d.name}`}>📌 {d.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Input
            type="date"
            value={newTask.due_date}
            onChange={(e) => setNewTask({ ...newTask, due_date: e.target.value })}
            className="rounded-xl"
          />
          <Textarea
            value={newTask.description}
            onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
            placeholder="Descrizione (opzionale)"
            className="rounded-xl"
          />
          <div className="flex gap-4 p-3 bg-gray-50 rounded-xl">
            <label className="flex items-center gap-2 cursor-pointer">
              <Checkbox checked={newTask.is_urgent} onCheckedChange={(c) => setNewTask({ ...newTask, is_urgent: c })} />
              <span className="text-sm flex items-center gap-1">
                <AlertTriangle className="w-3 h-3 text-red-500" /> Urgente
              </span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <Checkbox 
                checked={newTask.is_priority} 
                onCheckedChange={(c) => setNewTask({ ...newTask, is_priority: c })}
                disabled={!editingTask?.is_priority && priorityTasksCount >= 3}
              />
              <span className="text-sm flex items-center gap-1">
                <Star className="w-3 h-3 text-amber-500" /> Top 3
              </span>
            </label>
          </div>
          <Button type="submit" className="w-full rounded-xl">
            {editingTask ? "Aggiorna" : "Aggiungi"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default TaskForm;
